import Urls from "../../constants/urls";
import c4BackCar from './imgs/c4BackCar.jpg';
import frontCar from './imgs/frontCar.jpg';
import incCar from './imgs/incCar.jpg';
import lounge from './imgs/lounge.jpg';
import frontEntrance from './imgs/frontEntrance.jpg';

export const c4BackCarHotspots = [
    {
        type: "arrow",
        xPosition: 80,
        yPosition: -50,
        zPosition: -30,
        xRotation: 265,
        yRotation: 200,
        zRotation: 190,
        radius: 9,
        link: Urls.AutoShowroom.lounge.path,
        linkRotation: 80,
    },
    {
        type: "arrow",
        xPosition: -130,
        yPosition: -50,
        zPosition: -36,
        xRotation: 268,
        yRotation: 205,
        zRotation: 320,
        radius: 10,
        link: Urls.AutoShowroom.frontEntrance.path,
        linkRotation: 80,
    },
];

export const loungeHotspots = [
    {
        type: "arrow",
        yPosition: -20,
        zPosition: -54,
        xPosition: 30,
        xRotation: 265,
        yRotation: 87,
        zRotation: 330,
        radius: 6,
        link: Urls.AutoShowroom.c4BackCar.path,
        linkRotation: 0,
    },
    {
        type: "spot",
        yPosition: -10,
        zPosition: 40,
        xPosition: 55,
        xRotation: 260,
        yRotation: 60,
        zRotation: 10,
        radius: 4,
        link: Urls.AutoShowroom.frontCar.path,
        linkRotation: 100,
    },
];

export const frontCarHotspots = [
    {
        type: "arrow",
        yPosition: -20,
        zPosition: 5,
        xPosition: 45,
        xRotation: 265,
        yRotation: 87,
        zRotation: 270,
        radius: 6,
        link: Urls.AutoShowroom.frontEntrance.path,
        linkRotation: 80,
    },
    {
        type: "arrow",
        xPosition: -120,
        yPosition: -60,
        zPosition: -100,
        xRotation: 270,
        yRotation: 87,
        zRotation: 20,
        radius: 20,
        link: Urls.AutoShowroom.lounge.path,
        linkRotation: 80,
    }
];

export const frontEntranceHotspots = [
    {
        type: "spot",
        yPosition: -15,
        zPosition: -3,
        xPosition: 65,
        xRotation: 258,
        yRotation: 85,
        zRotation: 290,
        radius: 4,
        link: Urls.AutoShowroom.incCar.path,
        linkRotation: 100,
    },
    {
        type: "arrow",
        yPosition: -15,
        zPosition: -40,
        xPosition: 55,
        xRotation: 262,
        yRotation: 85,
        zRotation: 300,
        radius: 5,
        link: Urls.AutoShowroom.frontCar.path,
        linkRotation: 0,
    },
    {
        type: "arrow",
        yPosition: -20,
        zPosition: 50,
        xPosition: 35,
        xRotation: 264,
        yRotation: 15,
        zRotation: -45,
        radius: 5,
        link: Urls.AutoShowroom.c4BackCar.path,
        linkRotation: 0,
    },
    {
        type: "play",
        yPosition: -15,
        zPosition: 5,
        xPosition: 65,
        xRotation: 258,
        yRotation: 85,
        zRotation: 195,
        radius: 4,
        channel: "youtube",
        videoId: "fssMRLh80VU",
        // link: Urls.AutoShowroom.lounge.path,
        linkRotation: 80,
    },
];

export const incCarHotspots = [
    {
        type: "spot",
        xPosition: -65,
        yPosition: -15,
        zPosition: -40,
        xRotation: 0,
        yRotation: 45,
        zRotation: 0,
        radius: 6,
        link: Urls.AutoShowroom.frontEntrance.path,
        linkRotation: 80,
    }
];

export const rooms = [
    {
        name: "Back View of Vehicle",
        img: c4BackCar,
        route: Urls.AutoShowroom.c4BackCar,
        yRotation: 360,
    },
    {
        name: "Front View of Room",
        img: frontEntrance,
        route: Urls.AutoShowroom.frontEntrance,
        yRotation: 360,
    },
    {
        name: "Inside of Vehicle",
        img: incCar,
        route: Urls.AutoShowroom.incCar,
        yRotation: -88,
        linkRotation: 100,
    },
    {
        name: "Front View of car",
        img: frontEntrance,
        route: Urls.AutoShowroom.frontEntrance,
        yRotation: 90,
    },
    {
        name: "Right View of Vehicle",
        img: lounge,
        route: Urls.AutoShowroom.lounge,
        yRotation: 180,
    },
    {
        name: "Front View of Car",
        img: frontCar,
        route: Urls.AutoShowroom.frontCar,
        yRotation: 90,
        linkRotation: 0,
    },
];
